import { NgComponentOutlet } from '@angular/common';
import { Component, computed, input, Signal } from '@angular/core';
import { BaseComponent } from '@shared/classes';
import { ContactFormConfig, DynamicComponent } from '@shared/models';

import { Variant1Component } from './variant1/variant1.component';
import { Variant2Component } from './variant2/variant2.component';

@Component({
  selector: 'b2c-contact-form',
  imports: [NgComponentOutlet],
  templateUrl: './contact-form.component.html',
})
export class ContactFormComponent extends BaseComponent {
  config = input.required<ContactFormConfig>();

  public components: Signal<DynamicComponent<ContactFormConfig>> = computed(
    () => {
      return {
        [this.Variants.VARIANT_1]: {
          component: Variant1Component,
          inputs: { config: this.config() },
        },
        [this.Variants.VARIANT_2]: {
          component: Variant2Component,
          inputs: { config: this.config() },
        },
      };
    }
  );
}
